import { styled } from '@withjoy/joykit';

export const Container = styled.div`
  padding: 2rem;
  padding-top: 1rem;
  padding-bottom: 4rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  color: white;
  background-color: hsl(0, 0%, 25%);
  min-height: 100vh;
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;

  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto auto auto;
  align-items: center;
  padding: 1rem 2rem;
  row-gap: 0.375rem;
  column-gap: 1rem;

  background-color: hsl(0, 0%, 25%);
  box-shadow: 0 0 20px 0 hsl(0, 0%, 25%);
  color: white;
  font-size: 0.8125rem;
`;

export const Select = styled.select`
  border: 0;
  background-color: hsla(0, 0%, 100%, 0.1);
  padding: 0.6rem;
  font-size: 0.8rem;
  color: white;
  appearance: none;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const Sliders = styled.div`
  display: grid;
  grid-template-columns: 2.5rem 1fr;
  row-gap: 0.675rem;
  column-gap: 0.5rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TextArea = styled.textarea`
  resize: none;
  width: 100%;
  height: 100px;
  font-size: 0.9rem;
  padding: 1rem;
  line-height: 1.5;
  color: white;
  background-color: hsla(0, 0%, 100%, 0.1);
  border: 0;

  &:focus {
    outline: none;
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

export const Input = styled.input`
  border: 0;
  background-color: hsla(0, 0%, 100%, 0.1);
  color: white;
  padding: 0.6rem;
  font-size: 0.8rem;

  &:focus {
    outline: none;
  }

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;
